<template>
    <div class="card">
        <div class="row">
            <!-- Left side: Course image, title and description -->
            <div class="col-12 col-md-9 border-right">
                <div class="mt-05 ml-05">
                    <!-- Display the course thumbnail -->
                    <img class="rounded m-05" :src="item.cart.thumbnailUrl" height="50" width="50">
                </div>
                <div>
                    <h4 class="ml-1" v-text="item.cart.title"></h4>
                    <!-- Truncate the course description -->
                    <p class="ml-1" v-html="truncate(item.cart.description, 250)"></p>
                </div>
            </div>
            <!-- Right side: Price, quantity selector and remove button -->
            <div class="col-12 col-md-3 pt-05 text-center">
                <!-- Use the same currency filter as products -->
                <span class="font-large-1" v-text="$options.filters.currency(data.price, site_tax)"></span>
                <span class="font-small-1 text-muted d-block" style="margin-top: -5px;">inc {{ site_tax.name }}</span>
                <div class="mt-05">
                    <span class="font-small-2 text-center">Quantity:</span>
                    <div class="d-flex mb-05 mt-05">
                        <div class="m-auto">
                            <NumberInputSpinner
                                :min="1"
                                :max="5000"
                                :step="1"
                                :integerOnly="true"
                                v-model="qty"
                            />
                        </div>
                    </div>
                </div>
                <div class="text-center mb-05">
                    <button class="btn-sm btn-flat-danger" @click="destroy" style="border:none;">
                        <i class="feather icon-x"></i> {{ __('globals.remove') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NumberInputSpinner from 'vue-number-input-spinner';

export default {
    name: "course",
    props: ['data', 'index'],
    components: {
        NumberInputSpinner,
    },
    data() {
        return {
            item: this.data,
            qty: this.data.qty,
            site_tax: window.App.site_tax
        };
    },
    methods: {
        destroy() {
            this.$emit('deleted', { index: this.index });
        },
        truncate(text, length) {
            if (!text) return '';
            return text.length > length ? text.substring(0, length) + '...' : text;
        }
    },
    watch: {
        qty(val) {
            axios
                .patch('/member/cart/' + this.data.id, {
                    qty: val
                })
                .then((response) => {
                    this.$emit('updated', { qty: val, index: this.index });
                })
                .catch((error) => {
                    // Handle error as needed
                });
        }
    },
};
</script>

<style scoped>
/* Add any scoped styles here */
</style>
